module.exports = __webpack_public_path__ + "static/media/pay-applepay-off.82b73310.png";